import PropTypes from 'prop-types'

import CardThumbnail from '@adv-mt/mt-card-thumbnail'
import ListMobileScroll from '@adv-mt/mt-list-mobile-scroll'

import {NavigationCard} from './components/navigationCard.js'
import {SIZES} from './settings.js'

export {CardAdContent} from './components/cardAdContent.js'
export {CardModelContent} from './components/cardModelContent.js'

const onClickNavigationCard = () => {}

const DEFAULT_TITLE = () => <></>
const POSITION_FIRST = 'first'

const getItems = ({items = [], navigationOptions, size}) => {
  const navigationCard = navigationOptions && createNavigationCard({navigationOptions, size})
  const isPositionFirst = navigationOptions && navigationOptions.position === POSITION_FIRST
  return [
    isPositionFirst ? navigationCard : null,
    ...items.map(item => {
      return () => <CardThumbnail {...item} size={size} />
    }),
    !isPositionFirst ? navigationCard : null
  ].filter(Boolean)
}

const createNavigationCard = ({navigationOptions, size}) =>
  navigationOptions.label && navigationOptions.url
    ? () => <NavigationCard onClick={onClickNavigationCard} size={size} {...navigationOptions} />
    : null

const ListCarousel = ({items = [], navigationOptions, size = SIZES.SMALL, title: Title = DEFAULT_TITLE}) => {
  if (!items.length) return <></>
  return (
    <div className="mt-ListCarousel">
      <Title />
      <ListMobileScroll items={getItems({items, navigationOptions, size})} />
    </div>
  )
}

ListCarousel.displayName = 'ListCarousel'
ListCarousel.propTypes = {
  items: PropTypes.array,
  navigationOptions: PropTypes.objectOf({
    label: PropTypes.string,
    url: PropTypes.string
  }),
  size: PropTypes.oneOf(Object.values(SIZES)),
  title: PropTypes.node
}

export default ListCarousel

export {SIZES as listCarouselSizes}
